module.exports = __webpack_public_path__ + "img/coupon5.d545f1f9.png";